import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';

const defaultAuthState = {
  accessToken: null,
  isAuth: false,
};

export const useAuthStore = create(
  devtools(
    persist(
      (set) => ({
        ...defaultAuthState,

        setAccessToken: (accessToken) => set({ accessToken }),
        setIsAuth: (isAuth) => set({ isAuth }),

        resetAuthState: () => set(defaultAuthState),
      }),
      {
        name: 'auth-storage',
        storage: createJSONStorage(() => localStorage),
      }
    ),
    { name: 'Auth Store' }
  )
);
